import React, { useEffect } from "react";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import _ from "lodash";
import LottieLoader from "../LottieLoader";
import lottieLoaderFile from "../../files/animation/loading.json";
import lottieEmptyFile from "../../files/animation/empty_new.json";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useFetch2 } from "components/utils/authenticatedHook";
import EducationQuestionDetails from "./EducationQuestionDetails";
import { pasteValue } from "../Reusable/OnPasteValue";
import encryptRequest from "../../helpers/encryptationHelper";

function EducationMaterialQuestionList(props) {
    let [{ response: questions, error: questionError, isLoading: educationMaterialQuestionsLoader }, doFetch] = useFetch2();
    let [{ response: questionDelete, error: questionDeleteError, isLoading: questionDeleteLoader }, doFetch2] = useFetch2();
    let [{ response: educationMaterial, error: educationMaterialError, isLoading: educationMaterialLoader }, doFetch3] = useFetch2();
    const {
        educationMaterialQuestions = [],
        limit = 0,
        page = 0,
        totalPages = 0,
        totalCount = 0,
    } = questions?.data || {};
    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            {"   "}Showing {from} to {to} of {size} Results
        </span>
    );
    const options = {
        page: parseInt(page || 0),
        sizePerPage: parseInt(limit || 0),
        totalSize: parseInt(totalCount || 0),
        firstPageText: "First",
        prePageText: "Back",
        nextPageText: "Next",
        lastPageText: "Last",
        nextPageTitle: "First page",
        prePageTitle: "Previous page",
        firstPageTitle: "Next page",
        lastPageTitle: "Last page",
        hideSizePerPage: parseInt(totalCount) == 0 ? true : false, // Hide the sizePerPage dropdown always
        hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
        showTotal: parseInt(totalCount) == 0 ? false : true,
        paginationTotalRenderer: customTotal,
        sizePerPageList: [
            {
                text: "10",
                value: 10,
            },
            {
                text: "25",
                value: 25,
            },

            {
                text: "50",
                value: 50,
            },
            {
                text: "100",
                value: 100,
            },
        ], // A numeric array is also available. the purpose of above example is custom the text
    };

    function educationQuestions(filter) {
        const query = {
            page: filter?.page ?? 1,
            limit: filter?.limit ?? 10,
            sortOrder: filter?.sortOrder ?? "desc",
            sortFiled: filter?.sortFiled ?? "createdAt",
        };
        if (filter && filter.search) {
            query.search = filter.search;
        }
        doFetch({
            url: "/get-education-material-questions",
            method: "GET",
            disableWait: true,
            query: query,
        });
    }
    function paginationEducationList(type, { page, sizePerPage, filters, sortField, sortOrder }) {
        let data = { page: page, limit: sizePerPage };
        if (sortField) {
            data.sortFiled = sortField;
        }
        if (sortOrder) {
            data.sortOrder = sortOrder;
        }
        educationQuestions(data);
    }
    let debounceTimeout;
    function handleSearch(event) {
        const value = event.target.value;

        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            educationQuestions({ search: value });
        }, 500);
    }

    useEffect(() => {
        educationQuestions()
        doFetch3({
            url: "/get-education-material-type",
            method: "GET",
            disableWait: true,
        });
    }, [])
    useEffect(() => {
        if (questionDeleteLoader) {
            educationQuestions()
        }
    }, [questionDeleteLoader])
    function deleteQuestion(event) {
        if (event) {
            doFetch2({
                url: "/delete-education-material-questions/" + encryptRequest(event._id),
                method: "DELETE",
                disableWait: true,
            })
        }
    }
    function editQuestionReload(event) {
        if (event) {
            educationQuestions();
        }
    }
    return (
        <div style={{ marginTop: '2%' }}>
            <div>
                <input
                    type="text"
                    className="form-control input-date-filter remove-bottom-margin mb-3 mr-3 w-100"
                    id="exampleInputName1Test"
                    style={{ fontSize: "20px" }}
                    placeholder="Search name, material type, created by"
                    onChange={handleSearch} // Call handleChange on every input change
                    onPaste={(e) => {
                        e.preventDefault();
                        const event = pasteValue(e);
                        handleSearch(event);
                    }}
                />
            </div>
            <div>
                <BootstrapTable
                    remote={{
                        sort: false,
                        pagination: true,
                        filter: true,
                        search: true,
                    }}
                    wrapperClasses="table-responsive"
                    keyField="_id"
                    noDataIndication={() => {
                        return (
                            <div>
                                {educationMaterialQuestionsLoader && (
                                    <LottieLoader
                                        loadLoop={true}
                                        autoplayLoop={true}
                                        source={lottieLoaderFile}
                                        Lheight={150}
                                        Lwidth={150}
                                        subTitle={"Please Wait ..."}
                                    />
                                )}
                                {!educationMaterialQuestionsLoader && (
                                    <LottieLoader
                                        loadLoop={true}
                                        autoplayLoop={true}
                                        source={lottieEmptyFile}
                                        Lheight={300}
                                        Lwidth={300}
                                        title={"Sorry! No data found"}
                                        subTitle={
                                            "We can't find any educational questionnaire."
                                        }
                                    />
                                )}
                            </div>
                        );
                    }}
                    data={educationMaterialQuestionsLoader ? [] : educationMaterialQuestions}
                    columns={[
                        {
                            dataField: "name",
                            text: "Name",
                            sort: true,
                            formatter: (cell) => (
                                <div style={{ display: 'flex', alignItems: 'center', height: '100%', minHeight: '40px'}}>
                                    <p style={{ margin: 0, fontSize: '14px' }}>
                                        {cell ? cell : "-"}
                                    </p>
                                </div>
                            )
                        },
                        {
                            dataField: "educationMaterialType",
                            text: "Material type",
                            sort: true,
                            formatter: (cell) => (
                                <div style={{ display: 'flex', alignItems: 'center', height: '100%', minHeight: '40px'}}>
                                    <p style={{ margin: 0, fontSize: '14px' }}>
                                        {cell.materialType ? cell.materialType : "-"}
                                    </p>
                                </div>
                            )
                        },
                        {
                            dataField: "createdByName",
                            text: "Created by",
                            sort: false,
                            formatter: (cell) => (
                                <div style={{ display: 'flex', alignItems: 'center', height: '100%', minHeight: '40px' }}>
                                    <p style={{ margin: 0, fontSize: '14px' }}>
                                        {cell ? cell : "-"}
                                    </p>
                                </div>
                            )
                        },
                        {
                            dataField: "createdAt",
                            text: "Created date",
                            formatter: (cell) => (
                                <div style={{ display: 'flex', alignItems: 'center', height: '100%', minHeight: '40px' }}>
                                    <p style={{ margin: 0, fontSize: '14px' }}>
                                        {cell ? moment(cell).format("MMMM DD, YYYY hh:mm:ss A") : "-"}
                                    </p>
                                </div>
                            ),
                            sort: true,
                        }
                    ]}
                    pagination={options.page > 0 ? paginationFactory(options) : undefined}
                    bordered
                    onTableChange={paginationEducationList}
                    expandRow={{
                        renderer: (row) => { return <div style={{ margin: 15 }}><EducationQuestionDetails questionDetails={row} isQuestionnaireDelete={deleteQuestion} editQuestion={editQuestionReload} educationMaterial={educationMaterial} educationMaterialLoader={educationMaterialLoader} /></div> },
                        onlyOneExpanding: false,
                        showExpandColumn: true,
                        expandByColumnOnly: false,
                    }}
                ></BootstrapTable>
            </div>
        </div>
    );
}


export default EducationMaterialQuestionList;
